module.exports = __webpack_public_path__ + "img/logo.a00cb0d5.png";